export default {
    state: {
        roles: [],
        role: [],
        role_id: null,
        url: '/api/hms/users/roles',
        errors: {},
        table: {
            fields: [
                {key: 'code', label: 'Code', sortable: true, tdClass: ''},
                {key: 'name', label: 'Name', sortable: true, tdClass: ''},
                {key: 'updated_at', label: 'Updated At', sortable: true, tdClass: ''},
                {key: 'actions', label: 'Actions', thClass: 'text-center', tdClass: 'text-center'},
            ]
        },
        meta: {
            current_page: 1,
            per_page: 10,
            total: 0,
            from: '',
            to: '',
            sort: 'desc',
            order_by: 'Choose',
            sort_by: 'created_at',
            sort_desc: true,
            search: '',
            page_sizes: [10, 25, 50, 100],
        },
        form: {
            name: '',
        },
        permission_form: {
            names: [],
        },
    },

    getters: {
        getRoleTableFields: state => state.table.fields,

        getRolesMeta: state => state.meta,

        getRoleForm: state => state.form,

        getRoleErrors: state => state.errors,

        getRolePermissionForm: state => state.permission_form,
    },

    mutations: {
        setRoles: (state, payload) => {
            state.role = payload;
        },

        setRole: (state, payload) => {
            state.role_id = payload.role_id;
            state.role = payload;
        },

        setRolesMeta: (state, payload) => {
            state.meta = {...state.meta, ...payload};
        },

        setRoleErrors: (state, payload) => {
            state.errors = payload;
        },

        resetRolesMeta: state => {
            state.meta = {
                current_page: 1,
                per_page: 10,
                total: 0,
                from: '',
                to: '',
                sort: 'desc',
                order_by: 'Choose',
                sort_by: 'created_at',
                sort_desc: true,
                search: '',
                page_sizes: [10, 25, 50, 100],
            };
        },

        setRoleForm: state => {
            state.form = {
                name: '',
            };

            state.errors = {};
        },

        setRolePermissionForm: state => {
            state.form = {
                names: [],
            }
        }
    },

    actions: {
        fetchRole: ({state, commit}) => {
            let parameters = {
                page: state.meta.current_page,
                per_page: state.meta.per_page,
                sort_by: state.meta.sort_by,
                sort: state.meta.sort,
                search: state.meta.search,
            };


            if (!parameters.search && parameters.search.length <= 3) {
                delete parameters.search;
            }

            const roles = {
                "data": [
                    {
                        "role_id": 1,
                        "label": "Role1",
                        "data": {
                            "type": "Product Brands",
                            "attributes": {
                                "code": "ROL000001",
                                "name": "Role1",
                                "updated_at": "12-09-12",
                            }
                        },
                        "links": {"self": "roles\/1"}
                    },
                    {
                        "role_id": 2,
                        "label": "Role2",
                        "data": {
                            "type": "Product Brands",
                            "attributes": {
                                "code": "ROL000002",
                                "name": "Role2",
                                "updated_at": "12-10-12",
                            }
                        },
                        "links": {"self": "roles\/2"}
                    },
                    {
                        "role_id": 3,
                        "label": "Role3",
                        "data": {
                            "type": "Product Brands",
                            "attributes": {
                                "code": "ROL000002",
                                "name": "Role2",
                                "updated_at": "12-12-12",
                            }
                        },
                        "links": {"self": "roles\/3"}
                    }
                ],
                "links": {
                    "self": "\/roles",
                    "first": "http:\/\/pilot.test\/api\/ehms\/users\/roles?page=1",
                    "last": "http:\/\/pilot.test\/api\/ehms\/users\/roles?page=3",
                    "prev": null,
                    "next": "http:\/\/pilot.test\/api\/ehms\/users\/roles?page=2"
                },
                "meta": {
                    "current_page": 1,
                    "from": 1,
                    "last_page": 3,
                    "path": "http:\/\/pilot.test\/api\/ehms\/users\/roles",
                    "per_page": "10",
                    "to": 10,
                    "total": 21
                }
            };

            return new Promise((resolve, reject) => {
                commit('setRoles', roles);

                commit('setRolesMeta', roles.meta);

                resolve(roles);
            });
        },

        fetchEditRole: ({state, commit}, role_id) => {
            return new Promise((resolve, reject) => {
                axios.get(state.url + '/' + role_id + '/edit')
                    .then(response => {
                        state.role_id = response.data.id;

                        state.form = response.data;

                        resolve(response.data);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },

        submitRole: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.post(state.url, payload)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        commit('setRoleErrors', error.response.data.errors);

                        reject();
                    });
            })
        },

        updateRole: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.patch(state.url + '/' + state.role_id, payload)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        commit('setRoleErrors', error.response.data.errors);

                        reject();
                    });
            })
        },

        deleteRole: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.delete(state.url + '/' + payload.role_id)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                    });
            })
        },
    }
}
